import axiosPublicClient from "../../../../axiosPublicClient"

export default async (data) => {

    const result = await axiosPublicClient.post(`/retrieve-background-check-hit-results`, data)

    return result.data

}
